import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {ProductRoadmapComponent} from './productRoadmap.component';
const routes: Routes = [
  {
    path: '',
    component: ProductRoadmapComponent
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ProductRoadmapRoutingModule { }



// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/productRoadmap/productRoadmap-routing.module.ts